(function($) {


  function initAnalytics() {
    $('.c-header-search__close').click(function () {
      var conversion = {event: 'search', action: 'closed'};
      sendConversion(conversion);
    });
    $('.c-header-search__control').click(function () {
      var conversion = {event: 'search', action: 'opened'};
      sendConversion(conversion);
    });

    $('form.c-header-search__form').submit(function () {
      var searchedValue = $(this).find('input[name="q"]').val();
      var conversion = {event: 'search', action: 'search performed', label: searchedValue};
      sendConversion(conversion);
    });



    $('.c-category__sort.c-markets__tabs a').click(function () {
      var href = $(this).attr('href');
      if (href.indexOf("seradit=cena&seradit_zpusob=asc") >= 0) {
        var conversion = {event: 'orderingProduct', orderby: 'cena vzestupne'};
        sendConversion(conversion);
      } else if (href.indexOf("seradit=cena&seradit_zpusob=desc") >= 0) {
        var conversion = {event: 'orderingProduct', orderby: 'cena sestupne'};
        sendConversion(conversion);
      }
    });

    $('#search-dealer').click(function () {

      var conversion = {event: 'searchDealer'};
      sendConversion(conversion);

    });

    $('.basket-new input[name="platba"]').change(function () {
      if ($(this).is(':checked')) {
        var conversion = {event: 'changePaymentMethod', newPaymentMethod:  $.trim($(this).parent().find('.b-product-row__text').text())};
        sendConversion(conversion);
      }
    });
    $('.basket-new input[name="doprava"]').change(function () {
      if ($(this).is(':checked')) {
        var conversion = {event: 'changePaymentMethod', newPaymentMethod:  $.trim($(this).parent().find('.b-product-row__text').text())};
        sendConversion(conversion);
      }
    });

    $('.f-discount-code input[type="text"]').focus(function () {
      var conversion = {event: 'clickCoupon'};
      sendConversion(conversion);
    });

    $('.filter-info__title').click(function(){
      var conversion = {event:'clickInfo', info:$.trim($(this).find('span span').text())};
      sendConversion(conversion);
    });

    $('.c-product__category-col a.c-add__compare-add').click(function(){
      var href= $(this).attr('href');
      var href_parts = href.split('=')
      var conversion = {event:'addToComparison', product:$.trim($(this).parent().find('.c-product__text h3').text()), product_id:href_parts[href_parts.length-1]};
      sendConversion(conversion);
    });

    $('.c-product-hero__card__inner a.c-add__compare-add').click(function(){
      var href= $(this).attr('href');
      var href_parts = href.split('=')
      var conversion = {event:'addToComparison', product:$.trim($('#info h1.h3').text()), product_id:href_parts[href_parts.length-1]};
      sendConversion(conversion);
    });

    initFiltersAnalytics();

    setTimeout(
      function()
      {

        $('.c-product-hero__card .c-slider__pagination button').click(function(){
          var slideId = $(this).attr('aria-controls');
          var slideHref = $('#'+slideId).attr('href');
          var conversion = {event: 'clickGallery', image:slideHref};
          sendConversion(conversion);
        });
      }, 3000);




  }

  initAnalytics();




})(jQuery);

function sendConversion(conversion) {
  if (true) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(conversion);
  }

  console.log(conversion);
}

function initFiltersAnalytics(){
  $('#se-sorting form input').change(function () {

    var filterName = $.trim($(this).parents('.c-filter__group').find('.filter-info__title span').first().text()).replace(/\t/g, "");
    ;
    var conversion = {event: 'filterProduct', filterName: filterName, filterValue: $(this).val()};
    sendConversion(conversion);
  });
}

